/* eslint-disable */
import React from 'react';
import { connect } from 'react-redux';
import { Accordion, Form, OverlayTrigger, Popover } from 'react-bootstrap';
import { QuestionCircle } from 'react-bootstrap-icons';
import {
  openedFolder, openedFile, sourceRevision, targetRevision, xmlSourceFile, xmlTargetFile,
  revisionFetchIsLoading, revisionFetchHasErrored, revision, isFileStructureShowing,
} from '../actions/actionCreator';
import Loading from './Loading';
import { folderTooltips } from '../assets/js/tooltips.js';

const mapStateToProps = (state) => ({
  siteIdCurrent: state.siteId,
  showingFolders: state.isFileStructureShowing,
  fileStructureCurrent: state.fileStructure,
  openedFolderCurrent: state.openedFolder,
  openedFileCurrent: state.openedFile,
  fileFetchIsLoading: state.fileFetchIsLoading,
});

const mapDispatchToProps = (dispatch) => ({
  openedFolder: (folder) => dispatch(openedFolder(folder)),
  openedFile: (file) => dispatch(openedFile(file)),
  sourceRevision: (rev) => dispatch(sourceRevision(rev)),
  targetRevision: (rev) => dispatch(targetRevision(rev)),
  xmlSourceFile: (file) => dispatch(xmlSourceFile(file)),
  xmlTargetFile: (file) => dispatch(xmlTargetFile(file)),
  revisionFetchIsLoading: (isLoading) => dispatch(revisionFetchIsLoading(isLoading)),
  revisionFetchHasErrored: (hasErrored) => dispatch(revisionFetchHasErrored(hasErrored)),
  revision: (revisionLoaded) => dispatch(revision(revisionLoaded)),
  isFileStructureShowing: (bool) => dispatch(isFileStructureShowing(bool)),
});

class FolderView extends React.Component {
  state = { fileFilter: '' };

  getFileRevision(event, folder, file) {
    this.props.openedFile(file);
    this.props.sourceRevision(0);
    this.props.targetRevision(0);
    this.props.xmlSourceFile('');
    this.props.xmlTargetFile('');
    this.props.callDVS(
      this.props.revisionFetchIsLoading,
      this.props.revisionFetchHasErrored,
      this.props.revision,
      'REVISION',
      this.props.siteIdCurrent, folder, file,
    );
    document.getElementById('fileRevision').scrollTop = 0;
    this.props.routeHandler('REVISION', this.props.siteIdCurrent, folder, file);
  }

  containsSearchString(filename) {
    return filename.toString().toLowerCase().includes(this.state.fileFilter.toString().toLowerCase());
  }

  getFile(key, file) {
    let active = false;
    if (this.props.openedFileCurrent === this.props.fileStructureCurrent[key][file]) active = true;
    if (this.containsSearchString(this.props.fileStructureCurrent[key][file])) {
      return (
        <li
          key={file}
          onClick={(e) => this.getFileRevision(e, key, this.props.fileStructureCurrent[key][file])}
          className={active ? 'activeFile' : 'inActiveFile'}
        >
          {this.props.fileStructureCurrent[key][file]}
        </li>
      );
    }
    return null;
  }

  addTooltip(folder) {
    if (Object.prototype.hasOwnProperty.call(folderTooltips, folder)) {
      const tooltip = (
        <Popover id={`folder-tooltip-${folder}`}>
          <Popover.Body>{folderTooltips[folder]}</Popover.Body>
        </Popover>
      );
      return (
        <span>
          {`${folder} `}
          <OverlayTrigger trigger={['hover', 'focus']} rootClose overlay={tooltip} placement="right">
            <QuestionCircle role="button" className="tooltip-trigger" />
          </OverlayTrigger>
        </span>
      );
    }
    return <span>{folder}</span>;
  }

  getFolder(key, index) {
    return (
      <Accordion.Item eventKey={key} key={index}>
        <Accordion.Header>{this.addTooltip(key)}</Accordion.Header>
        <Accordion.Body>
          {this.props.fileStructureCurrent[key].length > 10 && (
            <Form.Group>
              <Form.Control
                type="text"
                placeholder="search"
                onChange={(e) => this.setState({ fileFilter: e.target.value })}
              />
            </Form.Group>
          )}
          <ul>
            {Object.keys(this.props.fileStructureCurrent[key]).map((file) => this.getFile(key, file))}
          </ul>
        </Accordion.Body>
      </Accordion.Item>
    );
  }

  handleFolderSelect = (activeKey) => {
    this.props.openedFolder(activeKey);
    this.setState({ fileFilter: '' });
  };

  componentDidMount() {
    if (this.props.fileQueryString) {
      this.props.callDVS(
        this.props.revisionFetchIsLoading,
        this.props.revisionFetchHasErrored,
        this.props.revision,
        'REVISION',
        this.props.accountQueryString,
        this.props.folderQueryString,
        this.props.fileQueryString,
      );
    }
  }

  render() {
    if (this.props.fileFetchIsLoading) return (<Loading />);
    const fileStruct = Object.keys(this.props.fileStructureCurrent).map(
      (key, index) => this.getFolder(key, index),
    );
    return (
      <div>
        <Accordion
          flush
          id="accordion"
          activeKey={this.props.openedFolderCurrent}
          onSelect={this.handleFolderSelect}
          className="account-structure"
        >
          {fileStruct}
        </Accordion>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FolderView);
